export default [
  {
    path: '/ip_access_block_log',
    name: 'ip_access_block_log',
    meta: {
      auth: false
    },
    component: () =>
      import(/* webpackChunkName: "ip_access_control" */ './AccessBlockLog.vue')
  },
  {
    path: '/ip_cust_blacklist_mgmt',
    name: 'ip_cust_blacklist_mgmt',
    component: () =>
      import(/* webpackChunkName: "ip_access_control" */ './BlackListMgmt.vue')
  },
  {
    path: '/ip_country_blacklist_mgmt',
    name: 'ip_country_blacklist_mgmt',
    component: () =>
      import(/* webpackChunkName: "ip_access_control" */ './CountryMgmt.vue')
  }
]
